import aesReduxConstants from '../../constants';

const clientInfoReducer = function() {
  const constants = aesReduxConstants;

  const defaultState = {
    id: null,
    contactMetEnabled: false,
    groupId: null,
    name: null,
    logo: null,
    enabled: true,
    former: false,
    demo: false,
    clusterToggling: true,
    updatedAt: null,
    createdAt: null,
    geoVersion: null,
    metInfoEnabled: false,
    assetReportEnabled: false,
    crmName: null,

    // New: default value for Beta Experience flag
    betaExperience: false,

    licenses: [],
  };

  const reducer = function(state, action) {
    if (state === undefined) {
      state = defaultState;
    }

    let delta = {};
    switch (action.type) {

      case constants.CLIENT.GET_CLIENT_LICENSES:
        delta = {
          licenses: normalizeByKey(action.licenses, 'name'),
        };
        break;

      case constants.GET_CLIENT_DETAILS:
        delta = {
          id: action.client.id,
          contactMetEnabled: action.client.contactMetEnabled,
          groupId: action.client.groupId,
          name: action.client.name,
          logo: action.client.logo,
          enabled: action.client.enabled,
          former: action.client.former,
          demo: action.client.demo,
          clusterToggling: action.client.clusterToggling,
          updatedAt: action.client.updatedAt,
          createdAt: action.client.createdAt,
          geoVersion: action.client.geoVersion,
          metInfoEnabled: action.client.metInfoEnabled,
          assetReportEnabled: action.client.assetReportEnabled,
          crmName: action.client.crmName,

          // New: hydrate Beta Experience flag from backend
          betaExperience: action.client.betaExperience,
        };
        break;

      default:
        return state;
    }

    return { ...state, ...delta };
  };

  return reducer;
};

export default clientInfoReducer();